export default "__VITE_ASSET__BDZmU0_8__"